{
  "status_submitted": "Received",
  "status_in_review": "Under review",
  "status_needs_info": "Needs your reply",
  "status_needs_info_staff": "Waiting for the resident",
  "status_processing": "In progress",
  "status_ready": "Ready",
  "status_completed": "Completed",
  "status_rejected": "Not approved",
  "status_cancelled": "Cancelled",
  "kind_service": "Service request",
  "kind_community_report": "Community concern",
  "kind_complaint": "Complaint",
  "class_simple": "Simple",
  "class_complex": "Complex",
  "class_highly_technical": "Highly technical",
  "classification": "Classification (RA 11032)",
  "classificationValue": "{name} · up to {count} working days",
  "filter_open": "Open",
  "filter_closed": "Closed",
  "filter_all": "All",
  "expectedBy": "Expected by {date}",
  "pastDeadline": "Past the expected date ({date})",
  "lateDays": "{count} working days late · due {date}",
  "workingDaysLimit": "{count} working days (RA 11032)",
  "processingLimit": "The office must act within {count} working days of receiving a complete request (RA 11032).",
  "clockStopped": "Deadline paused",
  "clockStarted": "Clock started",
  "closed": "Closed",
  "ev_created": "Request sent",
  "ev_status": "Status: {status}",
  "ev_internal": "Internal note",
  "ev_assigned": "Assignment",
  "ev_reply": "Message from the resident",
  "ev_attachment": "Files added",
  "ev_note": "Message from the office",
  "internalOnly": "only staff can see this",
  "historyTitle": "History",
  "filesTitle": "Files",
  "file": "File",
  "photo": "Photo",
  "fromOffice": "From the office",
  "addFile": "Add a photo or PDF",
  "uploading": "Uploading…",
  "removeFile": "Remove {name}",
  "fileHint": "Photos or PDF files, up to 2 MB each after compression.",
  "notEmergencyTitle": "Not for emergencies",
  "notEmergencyBody": "Fires, floods, accidents and anyone in danger: call 911 first.",
  "applyTitle": "Apply online",
  "applyFor": "Apply: {name}",
  "applyOnline": "Online request",
  "serviceNotFound": "We couldn't find that service.",
  "browseServices": "Browse services",
  "notOnlineTitle": "Apply at the office",
  "notOnlineBody": "{office} doesn't take this request online yet. Check the requirements and visit the office during office hours.",
  "seeRequirements": "See requirements",
  "officeDetails": "Office hours and contacts",
  "backToService": "Back to the service",
  "requirementsTitle": "Requirements",
  "requirementsLead": "Upload a photo or PDF of each document now, or bring the documents to the office. Uploading lets the office check them sooner.",
  "whereToSecure": "Where to get it: {place}",
  "formTitle": "Your details",
  "prefilledNote": "We filled in some details from your profile. Check them before you continue.",
  "detailsLabel": "Anything else the office should know",
  "detailsHint": "For example, a deadline you have or a question for the office.",
  "continueReview": "Review my request",
  "checkForm": "Please check the highlighted fields.",
  "consentRequired": "Please agree to the privacy notice to send this.",
  "reviewEyebrow": "Check your request",
  "reviewLead": "Make sure everything is correct, then send it.",
  "documents": "Documents",
  "documentsCount": "{count} files attached",
  "documentsNone": "None uploaded — you'll bring them to the office",
  "editAnswers": "Edit my answers",
  "afterSendNote": "You'll get a reference number. {office} has {count} working days to act once your request is complete, and you'll be notified at each step.",
  "sendRequest": "Send request",
  "sending": "Sending…",
  "sentTitle": "Request sent",
  "refLabel": "Reference number",
  "sentBody": "{office} received it. Expected by {date} ({count} working days). We'll notify you when it moves.",
  "trackThis": "Track this request",
  "reportTitle": "Report a concern",
  "reportLead": "Blocked drainage, damaged roads, streetlights, missed garbage collection… Tell the office in charge.",
  "noTypesTitle": "Concern reports aren't set up yet",
  "noTypesBody": "The LGU hasn't listed the kinds of concerns it takes in the app. Please contact the office in charge directly. For emergencies, call 911.",
  "contactOffice": "Find the office",
  "whatConcern": "What is the concern?",
  "chooseType": "Choose the kind of concern.",
  "routedTo": "Goes to {office} · target: {count} working days",
  "whereTitle": "Where is it?",
  "mapLabel": "Map: drop a pin where the problem is",
  "barangayOrPin": "Choose the barangay or drop a pin on the map.",
  "landmark": "Landmark",
  "landmarkPlaceholder": "e.g. beside the chapel, near the school gate",
  "whatHappened": "What did you see?",
  "describe": "Describe the concern",
  "describeHint": "What is wrong, since when, and who is affected.",
  "detailsRequired": "Describe the concern in a few words.",
  "yourDetails": "Your contact details",
  "nameRequired": "Add your name.",
  "mobileHint": "The office may text or call you for details.",
  "sendReport": "Send report",
  "reportSentTitle": "Report sent",
  "reportSentBody": "{office} received it. Target date: {date} ({count} working days). We'll notify you of updates.",
  "mineLead": "Everything you've sent to the LGU and where it stands.",
  "applyForService": "Apply for a service",
  "mineRequestsTitle": "Requests and concerns",
  "needsReplyCount": "{count} requests need your reply.",
  "mineEmptyOpen": "Nothing in progress. Requests you send will appear here.",
  "mineEmpty": "Nothing here yet.",
  "mineSignedOutTitle": "Your requests",
  "mineSignedOutBody": "Sign in to apply for services, report concerns and follow them here.",
  "registrationsLink": "Event registrations and tickets",
  "registrationsLinkHint": "Under My activity",
  "assessmentsTitle": "Tax assessments",
  "assessment_cedula_individual": "Community tax (individual)",
  "assessment_cedula_juridical": "Community tax (business)",
  "assessment_rpt": "Real property tax",
  "assessmentStatus_unpaid": "Pay at the counter",
  "assessmentStatus_paid": "Paid",
  "assessmentStatus_cancelled": "Cancelled",
  "orNumber": "OR no. {number}",
  "notFound": "We couldn't find that request.",
  "submittedOn": "Sent {date}",
  "closedOn": "Closed {date}",
  "liveUpdates": "Live updates",
  "readyService": "Ready. Bring your reference number and a valid ID when you claim it.",
  "readyOther": "The office has acted on this. It will be closed soon.",
  "askTitle": "{office} needs more from you",
  "askHint": "Reply below. When you send it, the office's processing time starts again.",
  "replyTitle": "Message the office",
  "replyAskedTitle": "Send what the office asked for",
  "replyLabel": "Message",
  "replyFiles": "Files",
  "replyEmpty": "Write a message or add a file.",
  "resubmit": "Send back to the office",
  "sendMessage": "Send message",
  "resubmittedToast": "Sent. The office will review it again.",
  "replySentToast": "Message sent.",
  "whatYouSent": "What you sent",
  "where": "Where",
  "pinned": "Pin at {lat}, {lng}",
  "aboutService": "About this service",
  "rateService": "How did we do? Rate this service",
  "cancelRequest": "Cancel this request",
  "cancelTitle": "Cancel this request?",
  "cancelBody": "The office will stop working on it. You can send a new request later.",
  "cancelYes": "Yes, cancel it",
  "cancelKeep": "Keep it",
  "cancelledToast": "Request cancelled.",
  "queueLead": "Applications, community concerns and complaints for this office. The earliest deadline comes first.",
  "exportCsv": "Export CSV",
  "searchLabel": "Search requests",
  "searchPlaceholder": "Reference, name or mobile number",
  "kindFilter": "Kind",
  "allKinds": "All kinds",
  "typeFilter": "Service or concern type",
  "allTypes": "All",
  "overdueOnly": "Overdue",
  "assignedToMe": "Assigned to me",
  "queueEmpty": "No requests here",
  "queueEmptyBody": "Try another filter. New requests appear here as soon as residents send them.",
  "showing": "Showing {shown} of {total}",
  "colRequest": "Request",
  "colFrom": "From",
  "colDeadline": "Deadline",
  "colAssigned": "Assigned to",
  "actionsTitle": "Next step",
  "whatTheySent": "What the resident sent",
  "nothingElse": "No other details.",
  "applicant": "Applicant",
  "reporter": "Reported by",
  "noContact": "No contact details (account deleted).",
  "handling": "Handling",
  "unassigned": "Not assigned",
  "assignedToast": "Assignment saved.",
  "action_in_review": "Start review",
  "action_needs_info": "Ask for more information",
  "action_processing": "Mark in progress",
  "action_ready": "Mark ready",
  "action_completed": "Mark completed",
  "action_rejected": "Don't approve",
  "action_submitted": "Reopen",
  "action_cancelled": "Cancel",
  "actionHint_in_review": "The resident sees that the office is reviewing it.",
  "actionHint_needs_info": "The deadline pauses until the resident replies. Say exactly what is missing.",
  "actionHint_processing": "The request is complete and being processed.",
  "actionHint_ready": "For documents: ready to claim. Tell the resident where and when.",
  "actionHint_completed": "Closes the request.",
  "actionHint_rejected": "Closes the request. Explain why and what the resident can do.",
  "actionHint_submitted": "Puts the request back in the queue.",
  "actionHint_cancelled": "Closes the request.",
  "noteToResident": "Note to the resident",
  "noteToResidentHint": "The resident is notified and sees this note.",
  "noteNeedsInfo": "Tell the resident what is missing.",
  "noteRejected": "Tell the resident why.",
  "statusChangedToast": "Status changed: {status}.",
  "noteKind": "Kind of note",
  "internalNote": "Internal note",
  "messageResident": "Message the resident",
  "internalLabel": "Internal note",
  "internalHint": "Only staff of this office see it.",
  "messageLabel": "Message to the resident",
  "messageHint": "The resident is notified.",
  "noteEmpty": "Write something first.",
  "saveNote": "Save note",
  "noteSavedToast": "Note saved.",
  "messageSentToast": "Message sent to the resident.",
  "mapPinLabel": "Map of where the concern is",
  "dashTitle": "Requests",
  "dashOpenQueue": "Open the queue",
  "dashOpen": "Open",
  "dashWaitingResident": "{count} waiting for the resident",
  "dashOverdue": "Overdue",
  "dashOverdueHint": "Past the RA 11032 limit",
  "dashDueWeek": "Due this week",
  "dashDueToday": "{count} due today",
  "dashOnTime": "Done on time",
  "dashOnTimeOf": "{onTime} of {total} in the last 30 days",
  "dashNoneCompleted": "None completed in the last 30 days",
  "dashMostOverdue": "Most overdue",
  "adminLead": "The kinds of concerns residents can report, and the office each one goes to. Until you add one, the Report a concern page tells residents it isn't set up yet.",
  "adminAdd": "Add concern type",
  "adminEdit": "Edit concern type",
  "adminEmpty": "No concern types yet",
  "adminEmptyBody": "Add the concerns your offices handle, for example blocked drainage (Engineering) or missed garbage collection (MENRO).",
  "adminName": "Name",
  "adminNameHint": "As residents would say it, e.g. \"Blocked drainage\".",
  "adminNameRequired": "Add a name.",
  "adminOffice": "Office in charge",
  "adminOfficeHint": "Reports of this kind go to this office's work queue.",
  "adminOfficeRequired": "Choose the office.",
  "adminChooseOffice": "Choose an office",
  "adminMunicipal": "Municipal offices",
  "adminBarangays": "Barangays",
  "adminClassHint": "The target response time shown to residents and used for overdue alerts.",
  "adminIcon": "Icon",
  "adminActive": "Residents can choose this",
  "adminActiveHint": "Turn off to stop new reports of this kind; existing ones stay.",
  "adminInactive": "Hidden",
  "adminSaved": "Concern type saved.",
  "adminMoveUp": "Move {name} up",
  "adminMoveDown": "Move {name} down",
  "holidaysLead": "RA 11032 deadlines count working days. Weekends are always skipped; list the regular and special non-working days here, including local holidays such as the town fiesta.",
  "holidayAddTitle": "Add a non-working day",
  "holidayName": "Name",
  "holidayNamePlaceholder": "e.g. All Saints' Day",
  "holidayAdd": "Add",
  "holidayAdded": "Holiday added.",
  "holidayDateRequired": "Choose the date.",
  "holidayNameRequired": "Add the name.",
  "holidaysIn": "Non-working days in {year}",
  "year": "Year",
  "holidaysEmpty": "No holidays listed for {year}",
  "holidaysEmptyBody": "Deadlines only skip weekends until you add holidays.",
  "holidayRemove": "Remove {name}",
  "holidayRemoved": "{name} removed.",
  "lateDays_one": "1 working day late · due {date}",
  "documentsCount_one": "1 file attached",
  "needsReplyCount_one": "1 request needs your reply."
}
